import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskValidationRow, TaskValidationRow } from "ui/Scripts/source/models/task/taskValidationRow";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";

export interface IReportGeneratedTableData {
    taskType: ITaskEditTypeItem;
    dataRows: ITaskDataRow[];
    validationRows: ITaskValidationRow[];

    getHash(): string;
}

export class ReportGeneratedTableData implements IReportGeneratedTableData {
    taskType: TaskEditTypeItem;
    dataRows: TaskDataRow[];
    validationRows: TaskValidationRow[];

    constructor();
    constructor(obj: IReportGeneratedTableData);
    constructor(obj?: any) {
        this.taskType = new TaskEditTypeItem(obj ? obj.taskType : null);
        this.dataRows = Base.getTypedArray(obj ? obj.dataRows : null, TaskDataRow);
        this.validationRows = Base.getTypedArray(obj ? obj.validationRows : null, TaskValidationRow);
        for (const dataRow of this.dataRows) {
            dataRow.initializeCols(this.taskType);
        }
    }

    getHash(): string {
        let result = this.taskType.getHash();
        for (const dataRow of this.dataRows) {
            result = result + "##" + dataRow.getHash();
        }
        return result;
    }
}